import { BLACK, NEAR_WHITE, WHITE } from "@shape/reef-shared";
import styled from "styled-components";

export const TopContainer = styled.div`
  background-color: ${BLACK};
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
`;

export const LogoImage = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 32px;

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    margin-left: 24px;
    margin-right: 6px;
    margin-top: 16px;
    color: ${WHITE};
  }
`;

export const Login = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const DividerBar = styled.div`
  width: 2px;
  height: 20px;
  background-color: ${NEAR_WHITE};
  margin: 0 16px;
`;
